module.exports = __webpack_public_path__ + "img/back_m_active1.26950d16.png";